var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHappyReaction(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#E3FFE0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3028_31888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5 20C32.5 26.9036 26.9036 32.5 20 32.5C13.0964 32.5 7.5 26.9036 7.5 20C7.5 13.0964 13.0964 7.5 20 7.5C26.9036 7.5 32.5 13.0964 32.5 20Z",
    fill: "#6BBC05",
    stroke: "#6BBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8255 23.0918C26.5936 26.2085 23.5544 28.413 19.9996 28.413C16.4449 28.413 13.4057 26.2081 12.1738 23.0918H27.8255Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2678 14.9004C16.5744 14.9004 17.6375 15.9635 17.6375 17.2701C17.6375 17.6337 17.3429 17.9283 16.9793 17.9283C16.6157 17.9283 16.3211 17.6337 16.3211 17.2701C16.3211 16.6893 15.8486 16.2168 15.2678 16.2168C14.687 16.2168 14.2148 16.6893 14.2148 17.2701C14.2148 17.6337 13.9202 17.9283 13.5566 17.9283C13.1931 17.9283 12.8984 17.6337 12.8984 17.2701C12.8984 15.9635 13.9615 14.9004 15.2678 14.9004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7291 14.9004C26.0357 14.9004 27.0988 15.9635 27.0988 17.2701C27.0988 17.6337 26.8041 17.9283 26.4406 17.9283C26.077 17.9283 25.7824 17.6337 25.7824 17.2701C25.7824 16.6893 25.3099 16.2168 24.7291 16.2168C24.1483 16.2168 23.6758 16.6893 23.6758 17.2701C23.6758 17.6337 23.3811 17.9283 23.0176 17.9283C22.654 17.9283 22.3594 17.6337 22.3594 17.2701C22.3597 15.9635 23.4224 14.9004 24.7291 14.9004Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3028_31888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyReaction);
export default __webpack_public_path__ + "static/media/happyReaction.d7b92b5e2d56072602217965c9eeb13b.svg";
export { ForwardRef as ReactComponent };